"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var ProductVariants_1 = __importDefault(require("../ProductVariants"));
var ProductExtraConfig_1 = __importDefault(require("../ProductExtraConfig"));
var CloseCircle_1 = require("@styled-icons/ionicons-outline/CloseCircle");
var reconnect_js_1 = require("reconnect.js");
function ProductExtraConfigInCart(props) {
  var item = props.item,
    disabled = props.disabled,
    onEditExtraData = props.onEditExtraData;
  var _a = react_1.default.useState(item.config.extra_data || {}),
    values = _a[0],
    setValues = _a[1];
  if (!item.product.extra_config_schema) {
    return null;
  }
  return react_1.default.createElement(ExtraWrapper, null, react_1.default.createElement("h3", null, "\u5BA2\u88FD\u9078\u9805"), react_1.default.createElement(ProductExtraConfig_1.default, {
    disabled: disabled,
    product: item.product,
    values: values,
    setValues: setValues
  }), !disabled && react_1.default.createElement("div", {
    className: "actions"
  }, react_1.default.createElement(antd_1.Button, {
    onClick: function onClick() {
      onEditExtraData(values);
    }
  }, "\u4FEE\u6539"), react_1.default.createElement(antd_1.Button, {
    type: "link",
    onClick: function onClick() {
      setValues(item.config.extra_data);
    }
  }, "\u9084\u539F")));
}
var ExtraWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px;\n  margin: 10px 0;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n  border-radius: 5px;\n  & > .actions {\n    display: flex;\n    justify-content: flex-end;\n  }\n"], ["\n  padding: 10px;\n  margin: 10px 0;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);\n  border-radius: 5px;\n  & > .actions {\n    display: flex;\n    justify-content: flex-end;\n  }\n"])));
function ItemInCart(props) {
  var _a, _b, _c;
  var item = props.item,
    index = props.index,
    disabled = props.disabled,
    editCartItem = props.editCartItem,
    removeFromCart = props.removeFromCart,
    customRenderer = props.customRenderer;
  var actions = reconnect_js_1.useOutlet('actions')[0];
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement(Content, null, react_1.default.createElement("div", {
    className: "product-info-box"
  }, react_1.default.createElement("img", {
    className: "product-img",
    alt: "product",
    src: ((_b = (_a = item.product.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.expected_url) || ((_c = item.product.images) === null || _c === void 0 ? void 0 : _c[0]) || '/images/site-logo.png'
  }), react_1.default.createElement("div", {
    className: "product-name"
  }, item.name, item.product.session && Object.keys(item.product.session).length > 0 && react_1.default.createElement("div", {
    className: "product-session"
  }, item.product.session.date + " " + item.product.session.start_time + "-" + item.product.session.end_time)), react_1.default.createElement("div", {
    className: "remove-product"
  }, !disabled && react_1.default.createElement("div", {
    className: "btn",
    onClick: function onClick() {
      return removeFromCart(index);
    }
  }, react_1.default.createElement(CloseCircle_1.CloseCircle, {
    size: 30,
    color: "#aaa"
  })))), react_1.default.createElement("div", {
    className: "product-variants"
  }, react_1.default.createElement(ProductVariants_1.default, {
    product: item.product,
    config: item.config,
    disabled: disabled,
    rowStyle: {
      justifyContent: 'flex-start'
    },
    onCartItemConfigChange: function onCartItemConfigChange(config) {
      return editCartItem(index, config);
    }
  })), react_1.default.createElement("div", {
    className: "product-price"
  }, react_1.default.createElement("div", {
    className: "label"
  }, actions.L('subtotal')), react_1.default.createElement("div", {
    className: "value"
  }, "$", item.amount)), react_1.default.createElement("div", {
    className: "remove-product"
  }, !disabled && react_1.default.createElement("div", {
    className: "btn",
    onClick: function onClick() {
      return removeFromCart(index);
    }
  }, react_1.default.createElement(CloseCircle_1.CloseCircle, {
    size: 30,
    color: "#aaa"
  })))), customRenderer ? customRenderer({
    index: index,
    item: item,
    disabled: disabled,
    editCartItem: editCartItem,
    removeFromCart: removeFromCart
  }) : react_1.default.createElement(ProductExtraConfigInCart, {
    item: item,
    disabled: disabled,
    onEditExtraData: function onEditExtraData(extra) {
      var nextConfig = {
        qty: item.config.qty,
        variants: item.config.variants,
        extra_data: extra
      };
      editCartItem(index, nextConfig);
    }
  }));
}
exports.default = ItemInCart;
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 10px 0;\n  border-bottom: 1px solid #ccc;\n"], ["\n  padding: 10px 0;\n  border-bottom: 1px solid #ccc;\n"])));
var Content = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n\n  & > * {\n    padding: 5px;\n  }\n\n  & > .product-info-box {\n    flex: 1 0 300px;\n    display: flex;\n    align-items: center;\n\n    & > img.product-img {\n      width: 120px;\n      height: 120px;\n      object-fit: contain;\n      border-radius: 12px;\n      background-color: #eee;\n      overflow: hidden;\n    }\n\n    & > .product-name {\n      white-space: pre-wrap;\n      flex: 1 0 100px;\n      margin-left: 8px;\n      fontsize: 0.8rem;\n    }\n\n    & > .remove-product {\n      display: none;\n      & > .btn {\n        cursor: pointer;\n      }\n    }\n  }\n\n  & > .product-variants {\n    flex: 0 0 150px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  & > .product-price {\n    flex: 0 0 100px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    & .label {\n      color: #888;\n      margin-right: 8px;\n      display: none;\n    }\n\n    & .value {\n      font-weight: 500;\n    }\n  }\n\n  & > .remove-product {\n    flex: 0 0 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    & > .btn {\n      cursor: pointer;\n    }\n  }\n\n  @media (max-width: 800px) {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    & > .product-info-box {\n      flex: 1 1 0px;\n\n      & > .remove-product {\n        display: block;\n      }\n    }\n\n    & > .product-variants {\n      flex: 1 1 0px;\n      justify-content: flex-start;\n    }\n\n    & > .product-price {\n      flex: 1 1 0px;\n      justify-content: flex-start;\n\n      & .label {\n        display: block;\n      }\n    }\n\n    & > .remove-product {\n      display: none;\n    }\n  }\n"], ["\n  display: flex;\n\n  & > * {\n    padding: 5px;\n  }\n\n  & > .product-info-box {\n    flex: 1 0 300px;\n    display: flex;\n    align-items: center;\n\n    & > img.product-img {\n      width: 120px;\n      height: 120px;\n      object-fit: contain;\n      border-radius: 12px;\n      background-color: #eee;\n      overflow: hidden;\n    }\n\n    & > .product-name {\n      white-space: pre-wrap;\n      flex: 1 0 100px;\n      margin-left: 8px;\n      fontsize: 0.8rem;\n    }\n\n    & > .remove-product {\n      display: none;\n      & > .btn {\n        cursor: pointer;\n      }\n    }\n  }\n\n  & > .product-variants {\n    flex: 0 0 150px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  & > .product-price {\n    flex: 0 0 100px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    & .label {\n      color: #888;\n      margin-right: 8px;\n      display: none;\n    }\n\n    & .value {\n      font-weight: 500;\n    }\n  }\n\n  & > .remove-product {\n    flex: 0 0 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    & > .btn {\n      cursor: pointer;\n    }\n  }\n\n  @media (max-width: 800px) {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    & > .product-info-box {\n      flex: 1 1 0px;\n\n      & > .remove-product {\n        display: block;\n      }\n    }\n\n    & > .product-variants {\n      flex: 1 1 0px;\n      justify-content: flex-start;\n    }\n\n    & > .product-price {\n      flex: 1 1 0px;\n      justify-content: flex-start;\n\n      & .label {\n        display: block;\n      }\n    }\n\n    & > .remove-product {\n      display: none;\n    }\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3;